import { render, staticRenderFns } from "./basicTable.vue?vue&type=template&id=39a52814&scoped=true"
import script from "./basicTable.vue?vue&type=script&lang=js"
export * from "./basicTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a52814",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a52814')) {
      api.createRecord('39a52814', component.options)
    } else {
      api.reload('39a52814', component.options)
    }
    module.hot.accept("./basicTable.vue?vue&type=template&id=39a52814&scoped=true", function () {
      api.rerender('39a52814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/contractLedger/components/basicTable.vue"
export default component.exports